import { LandPlot, Building2, Home, Recycle } from 'lucide-react'

export const developmentAreas = [
  {
    icon: LandPlot,
    title: 'Land Development',
    summary: 'Finding and unlocking the highest use of a property.',
    description:
      'Finding opportunities, evaluating property, entitlements, site development and preparing land for its highest use.',
    image:
      'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200&q=80',
  },
  {
    icon: Building2,
    title: 'Commercial Development',
    summary: 'Income-producing space built around how tenants operate.',
    description:
      'Commercial properties, tenant improvements, redevelopment and investment projects.',
    image:
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1200&q=80',
  },
  {
    icon: Home,
    title: 'Residential Development',
    summary: 'From single lots to full communities.',
    description:
      'Lots, communities, spec projects, luxury residential opportunities and larger development projects.',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&q=80',
  },
  {
    icon: Recycle,
    title: 'Redevelopment',
    summary: 'Turning overlooked property into its next chapter.',
    description:
      'Taking underperforming or outdated properties and creating something more valuable.',
    image:
      'https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?w=1200&q=80',
  },
]
